"use client";

import { cn } from "@/lib/utils";
import Image from "next/image";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { PageChallengeSchema } from "@/sanity/pages/PageChallengeTemplate";
import ChipSerif from "@/components/global/ui/ChipSerif";
import checkbox from "@/public/challenge/checkbox.svg";
import { motion } from "framer-motion";
import FAQList from "@/components/global/ui/FAQList";
import { PortableTextBlock } from "sanity";

export default function FaqSection({
  // data,
  className,
  chip,
  title,
  faqList,
}: {
  // data: PageChallengeSchema;
  chip: string;
  title: PortableTextBlock[];
  faqList: {
    question: string;
    answer: PortableTextBlock[];
  }[];
  className?: string;
}) {
  return (
    <section
      className={cn(
        "relative overflow-clip py-[7rem] lg:py-[20rem] px-[2rem] lg:px-0",
        className,
      )}
    >
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[38.25rem] sm:w-[55rem] lg:w-[min(180rem,80%)] h-full flex justify-between opacity-50 lg:opacity-100">
        {Array.from({ length: 7 }).map((_, index) => (
          <div
            key={index}
            className={cn(
              "h-full border-l border-l-[#E5E5E5]",
              index >= 5 && "hidden lg:block",
            )}
          />
        ))}
      </div>

      <div className="w-[min(119.875rem,100%)] mx-auto flex flex-col items-center py-[4.5rem] lg:py-[11.25rem] relative bg-white border border-[#E5E5E5] px-[2rem]">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
        >
          <ChipSerif text={chip} />
        </motion.div>

        {title && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="richtext"
          >
            <PortableText value={title} components={richTextComponent} />
          </motion.div>
        )}

        <FAQList faq={faqList} className="mt-[6rem] w-[min(89.375rem,100%)]" />
      </div>
    </section>
  );
}
